module.exports = __webpack_public_path__ + "img/logo_kks.a3932fa4.png";